import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface TakeControlDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  loading: boolean;
  description?: string;
}

function TakeControlDialog({
  open,
  onOpenChange,
  onConfirm,
  loading,
  description,
}: TakeControlDialogProps) {
  const { t } = useTranslation();

  const handleCancel = () => {
    onOpenChange(false);
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-lg font-semibold">
            {t('components.deal_control.take_control_dialog_title')}
          </DialogTitle>
        </DialogHeader>

        <p className="py-4 text-sm text-muted-foreground">
          {description ??
            t('components.deal_control.take_control_dialog_description')}
        </p>

        <DialogFooter className="flex gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={handleCancel}
            disabled={loading}
            className="flex items-center gap-2"
          >
            {t('general.cancel')}
          </Button>
          <Button
            type="button"
            variant="default"
            onClick={handleConfirm}
            disabled={loading}
            className="flex items-center gap-2"
          >
            {loading
              ? t('general.saving')
              : t('components.deal_control.take_control_confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default TakeControlDialog;
